function getOverviewSpacer() {
    return document.querySelector("#overview-spacer")
}

// Declare guard variables in the global scope to avoid redefining on every load
if (!window.overviewInitialized) {
    // Tracks the interval
    window.intervalId = null;
    // Flag to prevent duplicate listeners
    window.visibilityListenerAttached = false;
    // Guard to track whether overview.js has been initialized
    window.overviewInitialized = true;
}

document.addEventListener('turbolinks:load', function() {
    let overviewSpacer = getOverviewSpacer();
    if (!overviewSpacer) { return }
    const assignmentLaunchLeft = document.querySelector('.assignment-launch-left');
    const syncIcon = document.getElementById('last-updated-sync-icon');
    const syncRefreshTrigger = syncIcon?.closest('button') || syncIcon;
    const barManageCourseLink = document.getElementById('bar-manage-course-link');
    const refreshStatus = document.getElementById('overview-refresh-status');
    let shouldAnnounceRefresh = false;
    // free up the $ variable for use in jquery when turbolinks reloads javascript
    // if not loaded, enable the modal plugin
    if (typeof $().modal !== "function") { jQuery.noConflict() }

    // set up path for re-rendering overview contents
    const url = window.location.pathname;
    const matches = url.match(/\d+/g);
    const courseID = matches[0];
    const assignmentID = matches[1];
    const newPath = `/courses/${courseID}/assignments/${assignmentID}/overview`;

    // Submits an AJAX request to visit the current page again, updating the overview
    function updateOverviewPage() {
        let editMode = assignmentLaunchLeft?.dataset.editMode === "true";
        $.ajax({
            url: newPath,
            type: 'GET',
            dataType: 'html',
            success: function () {
                if (editMode === false) {
                    // Visit page with Turbolinks to avoid "flashing" header bar and page content
                    Turbolinks.ProgressBar.prototype.refresh = function() {}
                    Turbolinks.ProgressBar.defaultCSS = ""
                    Turbolinks.visit(location);
                    // Applies a spin animation to the sync icon
                    if (syncIcon) {
                        syncIcon.classList.add('sync-icon-spin-animation');
                        setTimeout(() => {
                            syncIcon.classList.remove('sync-icon-spin-animation');
                        }, 1500);
                    }
                    if (shouldAnnounceRefresh && refreshStatus) {
                        refreshStatus.textContent = 'Assignment overview updated.';
                        shouldAnnounceRefresh = false;
                    }
                }
            }
        });
    }

    function setFocusableState(element, isVisible) {
        if (!element) { return }

        const focusableElements = [element, ...element.querySelectorAll('a, button, input, select, textarea, [tabindex]')];
        focusableElements.forEach((focusableElement) => {
            if (!(focusableElement instanceof HTMLElement)) { return }

            if (!isVisible) {
                if (focusableElement.dataset.originalTabindex === undefined) {
                    focusableElement.dataset.originalTabindex = focusableElement.getAttribute('tabindex') || '';
                }
                focusableElement.setAttribute('tabindex', '-1');
            } else if (focusableElement.dataset.originalTabindex !== undefined) {
                if (focusableElement.dataset.originalTabindex === '') {
                    focusableElement.removeAttribute('tabindex');
                } else {
                    focusableElement.setAttribute('tabindex', focusableElement.dataset.originalTabindex);
                }
            }
        });
    }

    function setElementVisibility(element, isVisible, displayValue = null) {
        if (!element) { return }

        if (isVisible) {
            element.hidden = false;
            element.removeAttribute('aria-hidden');
            if (displayValue) {
                element.style.display = displayValue;
            } else {
                element.style.removeProperty('display');
            }
        } else {
            element.hidden = true;
            element.setAttribute('aria-hidden', 'true');
            element.style.setProperty('display', 'none', 'important');
        }

        setFocusableState(element, isVisible);
    }

    function showDecorativeSpacer(element) {
        if (!element) { return }

        element.hidden = false;
        element.setAttribute('aria-hidden', 'true');
        element.style.removeProperty('display');
        setFocusableState(element, false);
    }

    function visibilityHandler() {
        if (document.visibilityState === 'visible') {
            if (window.intervalId !== null) {
                // Clear any existing interval (extra safety)
                clearInterval(window.intervalId);
            }
            window.intervalId = setInterval(() => {
                updateOverviewPage();
            }, 1500);
        }
        else {
            // Clear the interval when the tab is hidden
            if (window.intervalId !== null) {
                clearInterval(window.intervalId);
                window.intervalId = null;
            }
        }
    }

    // Attach the visibilitychange listener only once
    if (!window.visibilityListenerAttached) {
        window.addEventListener('visibilitychange', visibilityHandler);
        window.visibilityListenerAttached = true;
    }

    // Changes the sync icon to appear clickable when hovered
    if (syncRefreshTrigger) {
        syncRefreshTrigger.style.cursor = 'pointer';
    }


    // Prevents default behavior for external course links, to prevent double tab opening
    barManageCourseLink?.addEventListener('click', function (event) {
        event.preventDefault();
    });

    // Applies a spin animation to the sync icon when clicked
    syncRefreshTrigger?.addEventListener('click', function () {
        shouldAnnounceRefresh = true;
        if (refreshStatus) {
            refreshStatus.textContent = 'Refreshing assignment overview.';
        }
        if (syncIcon) {
            syncIcon.classList.add('sync-icon-spin-animation');
            setTimeout(() => {
                syncIcon.classList.remove('sync-icon-spin-animation');
            }, 1500);
        }
    });

    // Assesses a data attribute in order to hide the new tab version of the edit button for immersive assignments
    let isImmersiveAssignment = assignmentLaunchLeft?.dataset.isImmersiveAssignment === "true";

    // The banner is shared by both contexts, so Manage Course is always displayed there.
    setElementVisibility(barManageCourseLink, true, "flex")
    showDecorativeSpacer(overviewSpacer);

    // The overview activity controls still use different link behavior in an iframe and a new tab.
    if (window.location !== window.parent.location) {
        // in iframe
        setElementVisibility(document.querySelector("#overview-assignment-launch-button-self"), false)
        setElementVisibility(document.querySelector("#edit-mode-action-button-container"), false)
        document.querySelectorAll("[id*='activity-title-overview-iframe']").forEach(element => {
            setElementVisibility(element, false);
        });
        document.querySelectorAll("[id*='activity-title-overview-new-tab']").forEach(element => {
            setElementVisibility(element, true);
        });
    } else {
        // not in iframe
        setElementVisibility(document.querySelector("#overview-assignment-launch-button-new"), false)
        document.querySelectorAll("[id*='activity-title-overview-new-tab']").forEach(element => {
            setElementVisibility(element, false);
        });
        document.querySelectorAll("[id*='activity-title-overview-iframe']").forEach(element => {
            setElementVisibility(element, true);
        });
        if (isImmersiveAssignment === true) {
            setElementVisibility(document.querySelector("#edit-mode-action-button-new-tab-container"), false)
        }
    }
});

// Turbolinks lifecycle: Clean up before navigating away to avoid duplication
document.addEventListener('turbolinks:before-render', () => {
    let overviewSpacer = getOverviewSpacer();
    if (!overviewSpacer) { return }
    // Clear active intervals
    if (window.intervalId !== null) {
        clearInterval(window.intervalId);
        window.intervalId = null;
    }
});
